import React from 'react';
import SideContainerComponent from '../SideContainer.component';
import { MainContentContainer, MainSection } from '../OtherPages.styles';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import PageHeader from '../../Components/PageHeader/PageHeader.component';
import Breadcrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import { DigitalFormsContent } from './Forms.styles';
import Overview from './Overview/Overview.component';
import Features from './Features/Features.component';
import Process from './Process/Process.component';
import Data from './Data/Data.component';
import Subscription from './Subscription/Subscription.component';
import Tools from './Tools/Tools.component';
import CTA from './CTA/CTA.component';
const Forms = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="Digital Safety Forms & Inspection Software"
        description="Turn existing PDF safety forms into digital forms your team can complete online, store, filter, and query. Contact Yoda Safety Services for subscription pricing."
      />

      <SideContainerComponent />
      <MainSection>
        <Breadcrumbs one="Home" oneLink="/" two="Digital Safety Forms" />

        <PageHeader
          eyebrow="Digital Safety Forms"
          title="Turn Your Existing Safety Forms Into Digital Tools"
          desc="Upload your existing PDF forms, have them configured for online use, and give your team a simpler way to complete, store, review, and search workplace safety records."
        />
        <DigitalFormsContent>
          {/* ----------------------------------
      Intro
  ----------------------------------- */}
          <Overview />

          {/* ----------------------------------
      Feature Strip
  ----------------------------------- */}
          <Features />

          {/* ----------------------------------
      How It Works
  ----------------------------------- */}

          <Process />

          {/* ----------------------------------
      Searchable Data
  ----------------------------------- */}

          <Data />

          {/* ----------------------------------
      Subscription
  ----------------------------------- */}

          <Subscription />
          {/* ----------------------------------
      Connected Tools
  ----------------------------------- */}
          <Tools />

          {/* ----------------------------------
      Final CTA
  ----------------------------------- */}
          <CTA />
        </DigitalFormsContent>
      </MainSection>
    </MainContentContainer>
  );
};

export default Forms;
